import React from 'react';
import Categories from '../components/categories/Categories';

const Home = () => {
  return (
    <Categories/>
  )
}

export default Home